/* Deal and Dink custom JS — rolling pickleball + video autoplay kicker */
(function(){
  function initBall(){
    if(document.getElementById('dnd-ball'))return;
    var b=document.createElement('div');
    b.id='dnd-ball';
    b.style.cssText='position:fixed;top:5px;left:0;z-index:9999;width:26px;height:26px;pointer-events:none;filter:drop-shadow(0 1px 3px rgba(0,0,22,0.6))';
    b.innerHTML='<svg viewBox="0 0 26 26" width="26" height="26"><circle cx="13" cy="13" r="11.5" fill="#98E94F" stroke="#000016" stroke-width="1.5"/><circle cx="8.5" cy="8" r="1.7" fill="#000016" opacity="0.5"/><circle cx="15" cy="6.5" r="1.7" fill="#000016" opacity="0.5"/><circle cx="18.5" cy="12" r="1.7" fill="#000016" opacity="0.5"/><circle cx="12" cy="13.5" r="1.7" fill="#000016" opacity="0.5"/><circle cx="7" cy="15.5" r="1.7" fill="#000016" opacity="0.5"/><circle cx="15.5" cy="18.5" r="1.7" fill="#000016" opacity="0.5"/><circle cx="10" cy="20" r="1.7" fill="#000016" opacity="0.5"/></svg>';
    document.body.appendChild(b);
    var ticking=false;
    function update(){
      ticking=false;
      var doc=document.documentElement;
      var max=doc.scrollHeight-window.innerHeight;
      var p=max>0?Math.min(1,Math.max(0,(window.scrollY||doc.scrollTop)/max)):0;
      var x=p*(window.innerWidth-34)+4;
      b.style.transform='translateX('+x+'px) rotate('+(x*4.4)+'deg)';
    }
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function initVideos(){
    var vids=document.querySelectorAll('#videos video');
    if(!vids.length)return;
    function kick(v){
      v.muted=true;
      v.setAttribute('muted','');
      v.setAttribute('playsinline','');
      v.playsInline=true;
      if(v.readyState===0){try{v.load();}catch(e){}}
      var p=v.play();
      if(p&&p.catch){p.catch(function(){});}
    }
    vids.forEach(kick);
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ kick(en.target); } });
      },{threshold:0.25});
      vids.forEach(function(v){io.observe(v);});
    }
    document.addEventListener('touchstart',function once(){vids.forEach(kick);document.removeEventListener('touchstart',once);},{passive:true});
  }
  function init(){ initBall(); initVideos(); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',initVideos);
})();
